<section id="modal" class="modal modal--{{modalData.type}}">
  <div class="modal-dialog">
    <div class="modal-content panel">
      <form class="mmb-form" #formAddPassword="ngForm" name="formAddPassword"
        (submit)="handleSubmit(formAddPassword.value, $event)" novalidate>

        <div class="panel__header">
          <div class="flex flex-always flex--space-between">
            <p class="text modal-title margin-bottom-0">{{ appCopy.panelHeader["passwordModalTitle" + selectedLanguage] }}</p>
            <a href="javascript:void(0);" class="modal-close" (click)="close($event)"><i class="icon">cross</i></a>
          </div>
        </div>
        <div class="panel__body">

          <div class="section">
            <p class="text-muted text-dark-blue">
              {{ appCopy.panelHeader["passwordModalContent" + selectedLanguage] }}
            </p>
          </div>

          <div class="section section__colored">
            <div class="form-group">
              <div class="passwordIcon">
              <input class="form-control" [ngClass]="{ 'has-error': Password.invalid && Password.dirty }" id="Password"
                name="Password" [type]="showPassword.password ? 'text' : 'password'" #Password="ngModel" [(ngModel)]="passwordValues.password1" ngModel (ngModelChange)="passwordsEqual(true)"
                required appCheckEmpty [placeholder]=" appCopy.panelHeader['loginPasswordLabel' + selectedLanguage] "
                />
                <div class="btntoggle" (click)="togglePasswordVisibility('password')">
                  <ng-container *ngIf="showPassword.password; else showPass">
                    <i class="icon-eye-blocked"></i>
                  </ng-container>
                  <ng-template #showPass>
                    <i class="icon-eye"></i>
                  </ng-template>
                </div>
              </div>
              <i class="icon control-validation-state"></i>
              <p class="help-block text-danger" *ngIf="Password.invalid && Password.dirty">
                {{ appCopy.panelHeader["warningEnterPassword" + selectedLanguage] }}
              </p>
            </div>


            <div class="form-group margin-top-16">
              <div class="passwordIcon">
              <input class="form-control" [ngClass]="{
                  'has-error':
                    (PasswordVerify.invalid && PasswordVerify.dirty) ||
                    !passwordMatch
                }" id="PasswordVerify" name="PasswordVerify" [type]="showPassword.confirmPassword ? 'text' : 'password'" #PasswordVerify="ngModel"
                [(ngModel)]="passwordValues.password2" (ngModelChange)="passwordsEqual()" ngModel
                [placeholder]=" appCopy.panelHeader['loginRePasswordLabel' + selectedLanguage]"  required appCheckEmpty />

                <div class="btntoggle" (click)="togglePasswordVisibility('confirmPassword')">
                  <ng-container *ngIf="showPassword.confirmPassword; else showConfirm">
                    <i class="icon-eye-blocked"></i>
                  </ng-container>
                  <ng-template #showConfirm>
                    <i class="icon-eye"></i>
                  </ng-template>
                </div>
              </div>
                <i class="icon control-validation-state"></i>

              <p class="help-block text-danger" *ngIf="PasswordVerify.invalid && PasswordVerify.dirty">
                {{ appCopy.panelHeader[ "warningReEnterPassword" + selectedLanguage ] }}
              </p>
              <p class="help-block text-danger" *ngIf="!passwordMatch">
                {{ appCopy.panelHeader["warningMatchPassword" + selectedLanguage] }}
              </p>
            </div>

          </div>

          <div class="section section__actions">
            <button class="btn btn-purple" type='submit' [disabled]="formAddPassword.invalid || !passwordMatch">
              <div class="loader-container-btn" *ngIf="showLoader">
                <div class="loader loader--white">
                  <svg class="circular" viewBox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" r="20" />
                  </svg>
                </div>
              </div>
              {{ appCopy.panelHeader["confirmButtonText" + selectedLanguage] }}
            </button>
          </div>
        </div>
      </form>

    </div>
  </div>
</section>
<app-notifications></app-notifications>
